import { app } from '../../../../bootstrap/core';
import { financesState } from './finances.state';
import { financesComponent } from './finances.component';

app.config(financesState);
app.component(financesComponent.name, financesComponent);
